/* 🤖 this file was generated by svg-to-ts*/
export const iconVideoTalk = {
  name: 'video_talk',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.8333 12.75V8.66667C19.8333 8.025 19.3083 7.5 18.6667 7.5H4.66667C4.025 7.5 3.5 8.025 3.5 8.66667V20.3333C3.5 20.975 4.025 21.5 4.66667 21.5H18.6667C19.3083 21.5 19.8333 20.975 19.8333 20.3333V16.25L24.5 20.9167V8.08333L19.8333 12.75Z" fill="#000000" fill-opacity="0.7"/>
  </svg>`,
}
